// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2s1mN","footer":"ChangeClinic_footer__2NwOX"};